"use client"

import { useCallback, useEffect, useState } from "react"
import fetchClientScrapIds from "@/app/(pages)/my/sentences/scrap/_fetch/fetchClientScrapIds"
import { pipe } from "fp-ts/lib/function"
import * as E from "fp-ts/Either"
import { useMyScrapsStore } from "./useMyScrapsStore"

const useMyScrapSentences = (enabled: boolean = true) => {
  const [hasHydrated, setHasHydrated] = useState(false)
  const {
    scrapIds,
    isLoading,
    setScraps,
    clear,
    isScrap,
    addScrapId,
    deleteScrapId,
  } = useMyScrapsStore()

  useEffect(() => {
    setHasHydrated(true)
  }, [])

  const fetch = useCallback(async () => {
    const result = await fetchClientScrapIds()
    pipe(
      result,
      E.match(
        () => {},
        (v) => {
          setScraps(v)
        },
      ),
    )
  }, [setScraps])

  useEffect(() => {
    if (!enabled) return
    if (!hasHydrated) return
    if (scrapIds != null || isLoading) {
      return
    }
    fetch()
  }, [enabled, hasHydrated, scrapIds, isLoading, fetch])

  return {
    scrapIds,
    isLoading,
    hasHydrated,
    fetch,
    clear,
    isScrap,
    addScrapId,
    deleteScrapId,
  }
}

export default useMyScrapSentences
